$(document).ready(function(){
  
  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 2000,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    adaptiveHeight: true,
  });

  //   function iconImgSlider() {
  //   if (window.innerWidth <= 1024) {
  //     if (!$('.custom_ic_img_sec .iconRow').hasClass('slick-initialized')) {
  //       $('.custom_ic_img_sec .iconRow').slick({
  //         dots: true,
  //         infinite: false,
  //         speed: 300,
  //         arrows:false,
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         responsive: [
  //           {
  //             breakpoint: 640,
  //             settings: {
  //               slidesToShow: 1
  //             }
  //           }
  //         ]
  //       });
  //     }
  //   } else {
  //     if ($('.custom_ic_img_sec .iconRow').hasClass('slick-initialized')) {
  //       $('.custom_ic_img_sec .iconRow').slick('unslick');
  //     }
  //   }
  // }
  // iconImgSlider();

  // $(window).on('resize', function () {
  //   iconImgSlider();
  // });


  $('.custom_videoGrid .main_video_content').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  
  $('.new-product-slider .featured-pro-slider.grid--uniform').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.shop-cat-sec .cat-img-row').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
  $('.collection-block-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
    
  $('.reviews-slider').slick({
    dots: true,
    arrows:false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.custom-cat-sec .cat-img-row').slick({
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: '40px',
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          centerPadding: '30px',
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerPadding: '20px',
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: '15px',
          slidesToScroll: 1,
        }
      }
    ]
  });

  
  $('.home-tabs-bg-sliders .product-list').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.featured-collection-slider .grid--uniform.featured-pro-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });


    $('.collection-type-data .coll-type-wrapper').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  });


   $('.product-slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product__photos .product__thumbs--scroller'
  });
  $('.product__photos .product__thumbs--scroller').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-slideshow',
    focusOnSelect: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".watch-us-sec .watch_video_contentt").slick({
    dots: false,
    infinite: true,
    fade: true,
    speed: 2000,
    arrows: true,
    slidesToShow: 1,
    autoplay: false,
    adaptiveHeight: true,
  });

  // $(".home-tabs-bg-sliders .tabs").slick({
  //   dots: false,
  //   infinite: true,
  //   fade: true,
  //   speed: 2000,
  //   arrows: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   adaptiveHeight: true,
  // });
 

});


$(".about-btn-click").click(function() {
  $(".popup").fadeIn(500);
});
$(".close").click(function() {
  $(".popup").fadeOut(500);
});
$(".popup").click(function() {
  $(this).fadeOut(500);
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp

$(".tab-container .tab_content").hide();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
    /* if in tab mode */
    $("ul.tabs li").click(function() {
      var parent = $(this).parents('.tab-container');
  
      $(parent).find(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $(parent).find("#"+activeTab).fadeIn();
  
      $(parent).find("ul.tabs li").removeClass("active");
      $(this).addClass("active");
  
      $(parent).find(".tab_drawer_heading").removeClass("d_active");
      $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
      $('.products-slider .product-list').slick('refresh');
  
    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function() {
      var parent = $(this).parents('.tab-container');
  
      $(parent).find(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $(parent).find("#"+d_activeTab).fadeIn();
  
      $(parent).find(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
  
      $(parent).find("ul.tabs li").removeClass("active");
      $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
      $('.products-slider .product-list').slick('refresh');
  });


$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");

// sections/take-outback-section click function
$('.take-icon').on('click', function (e) {
  e.stopPropagation(); // Prevent the click from bubbling to the body
  $('.take-icon-box').removeClass('show'); // Optional: close others
  $(this).closest('.take-icon-box').addClass('show');
});
$('body').on('click', function () {
  $('.take-icon-box').removeClass('show');
});


document.addEventListener("DOMContentLoaded", function () {

  function isMobileView() {
    return window.innerWidth <= 1199;
  }

  document.addEventListener("click", function (e) {
    if (!isMobileView()) return;

    const clickedItem = e.target.closest(".custom-nav-item.has-mega");
    const insideMegaMenu = e.target.closest(".mega-menu");
    const openItems = document.querySelectorAll(".custom-nav-item.has-mega.open");

    // ✅ Click on has-mega trigger (not inside mega content)
    if (clickedItem && !insideMegaMenu) {
      e.preventDefault();

      // 🔴 Close all other open mega menus
      openItems.forEach(item => {
        if (item !== clickedItem) {
          item.classList.remove("open");
        }
      });

      // 🟢 Toggle current
      clickedItem.classList.toggle("open");
      return;
    }

    // ✅ Click inside mega menu (tabs, content) → do nothing
    if (insideMegaMenu) {
      return;
    }

    // ✅ Outside click → close all
    openItems.forEach(item => item.classList.remove("open"));
  });

  // Desktop par aate hi reset
  window.addEventListener("resize", function () {
    if (!isMobileView()) {
      document
        .querySelectorAll(".custom-nav-item.has-mega.open")
        .forEach(item => item.classList.remove("open"));
    }
  });

});


document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.getElementById("NavDrawer");
  const body = document.body;

  if (!drawer) return;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(mutation => {
      if (mutation.attributeName === "class") {
        if (drawer.classList.contains("drawer--is-open")) {
          body.classList.add("no-scroll");
        } else {
          body.classList.remove("no-scroll");
        }
      }
    });
  });

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ["class"]
  });
});


